import { PermissionStatuses } from 'constants/Permissions.js';

export const hasActivePermission = (name, permissions) => {
  const permission =
    permissions && permissions.length > 0
      ? permissions.find(perm => perm.name === name)
      : null;

  if (!permission) {
    return false;
  } else if (permission && !permission.status) {
    return true; //Support legacy permissions
  } else if (permission.status === PermissionStatuses.enabled) {
    return true;
  } else {
    return true;
  }
};

export const getPermissionByName = (name = '', permissions = []) => {
  if (!permissions.length) return null;
  return permissions.find(item => item.name === name);
};
